import React from 'react';
import styles from './TotalProducts.module.css';

const TotalProducts = ({
  search,
  isPublic,
  filteredProductCount,
  totalProductCount,
  isLoading,
}) => {
  const filteredProductCountString =
    filteredProductCount && filteredProductCount.toLocaleString();
  const totalProductCountString =
    totalProductCount && totalProductCount.toLocaleString();

  if (isLoading) return <p className={styles.totalProducts}>-</p>;

  return (
    <p className={styles.totalProducts}>
      {search || isPublic !== null ? (
        <>
          <span>{filteredProductCountString}</span>
          {` of ${totalProductCountString} Shown`}
        </>
      ) : (
        <>
          <span>{totalProductCountString}</span> Total Products
        </>
      )}
    </p>
  );
};

export default TotalProducts;
